import { lazy } from 'react';

export const LazySignatureRequestsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--signature-requests-page" */ './signature-requests-page'
    ),
);
